/**
 * Which family a PRODUCT SKU belongs to, for the SP4 product catalog view.
 *
 * The list is DATA, in vendorRegistry — this module only applies it. Matching
 * is ordered and first-match-wins.
 *
 * Deliberately separate from `src/admin/catalog/categories.js`: that classifies
 * COMPONENTS by their cost `kind`, this classifies PRODUCTS by SKU shape. They
 * look alike and mean different things; merging them would make a component
 * category and a product family the same object, which they are not.
 */
import { isNodeSku } from '../pricing/seedBuilder';

export const UNCLASSIFIED = 'unclassified';
export const UNCLASSIFIED_LABEL = 'Unclassified';

function matches(family, sku) {
  if (family.node && isNodeSku(sku)) return true;
  if (family.prefixes?.some((p) => sku.startsWith(p))) return true;
  if (family.contains?.some((s) => sku.toUpperCase().includes(s))) return true;
  return false;
}

export function familyOf(sku, families) {
  for (const family of families ?? []) {
    if (matches(family, sku)) return family.id;
  }
  return UNCLASSIFIED;
}

/** Family id -> { label, offerings[] }, in the registry's order, with
 *  Unclassified last and ALWAYS present when it has members. Empty families
 *  are omitted, matching `groupByCategory`. */
export function groupByFamily(offerings, families) {
  const buckets = new Map(
    (families ?? []).map((f) => [f.id, { id: f.id, label: f.label, offerings: [] }]),
  );
  buckets.set(UNCLASSIFIED, { id: UNCLASSIFIED, label: UNCLASSIFIED_LABEL, offerings: [] });

  for (const offering of [...(offerings ?? [])].sort((a, b) => a.sku.localeCompare(b.sku))) {
    buckets.get(familyOf(offering.sku, families)).offerings.push(offering);
  }
  return [...buckets.values()].filter((b) => b.offerings.length > 0);
}
